import { Component, inject, signal } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';
import { ConfirmDialogComponent } from "./core/components/confirm-dialog/confirm-dialog.component";
import { AuthService } from './core/auth/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [LayoutComponent, ConfirmDialogComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('nombreproyecto-app');

}
